// extracted by mini-css-extract-plugin
export default {"dialogContainer":"PasswordDialog_dialogContainer__Rs-gh","submitBtn":"PasswordDialog_submitBtn__Ength"};